import React, {Component} from 'react';
import './NotFound.css';
import {Link} from 'react-router-dom';
import {Button} from 'reactstrap';
import NavBarKS from "../components/NavBarKS";

class NotFound extends Component {
	render() {
		return (
			<div className="row baseBackground">
				<NavBarKS offsetWidth={this.props.offsetWidth}>
				</NavBarKS>
				<div className="col-sm-12 page-not-found">
					<h1 className="title">
						404
					</h1>
					<div className="hata">
						Sayfa Bulunamadı.
					</div>
					<Link to="/"><Button className="TekBtn geri go-back-btn" type="primary" size="large">Ana Sayfaya
						Git</Button></Link>
				</div>
			</div>
		);
	}
}

export default NotFound;